import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import find from 'lodash/find';
import noop from 'lodash/noop';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ProductConstants from '../../common/ProductConstants';
import ProductModule from '../../selectors/ProductOptionsSelector';
import * as styles from './ProductOptions.css';

const BeautyDropDown = (props) => {
    const cx = classNames.bind(styles);

    const beautyDropdownRef = useRef();

    const changedOption = useSelector((state) => state.productOptions.option) || '';

    const [showItems, setShowItems] = useState(false);

    const dimensionWithUnavailableFiltersRemoved = ProductModule.removeUnavailableFilters(
        props.dimension
    );
    const selectedColor = find(props.optionsSelected, { type: 'COLOR' });
    const selectedColorDetails = dimensionWithUnavailableFiltersRemoved?.options.filter(
        (data) => data.value === selectedColor?.option
    );

    const beautyDropdownStyle = dt([
        'block',
        'relative',
        'text-left',
        showItems ? 'rounded-t-lg' : 'rounded-lg',
        'bg-white',
        'text-base',
        'lg:w-[300px]',
        'smMd:w-full',
        'py-[7px]',
        'pl-4',
        'pr-3',
        'z-[3]',
    ]);

    const toggleDropDown = () => {
        setShowItems(!showItems);
    };

    const closeDropDown = (event) => {
        !beautyDropdownRef.current.contains(event?.target) && setShowItems(false);
    };

    useEffect(() => {
        showItems && setShowItems(false);
    }, [changedOption]);

    useEffect(() => {
        document.addEventListener('mousedown', closeDropDown);
        return () => {
            document.removeEventListener('mousedown', closeDropDown);
        };
    }, []);

    return (
        <div
            ref={beautyDropdownRef}
            className={cx(beautyDropdownStyle, 'selectList', 'beautyDropdown')}
        >
            {/* eslint-disable-next-line react/button-has-type */}
            <button
                onClick={toggleDropDown}
                className={dt([
                    'block',
                    'relative',
                    'text-left',
                    'w-full',
                    'font-bold',
                    'before:content-[""]',
                    'before:border-l-[5px]',
                    'before:border-l-transparent',
                    'before:border-r-[5px]',
                    'before:border-r-transparent',
                    'before:border-t-[5px]',
                    'before:border-black',
                    'before:top-1/2',
                    'before:right-1',
                    'before:-translate-y-1/2',
                    'before:absolute',
                ])}
            >
                {selectedColorDetails.length > 0 ? (
                    <div
                        className={`${cx('beautyDropdown_list', 'beautyDropdown_selected')} ${dt([
                            'font-bold',
                            'border-t-0',
                        ])}`}
                    >
                        {props.renderProductOptionsColorItem(
                            props.dimension,
                            selectedColorDetails[0],
                            0,
                            true
                        )}
                    </div>
                ) : (
                    <div className={dt(['flex'])}>
                        <span
                            className={dt([
                                'w-8',
                                'h-8',
                                'block',
                                'relative',
                                'rounded-full',
                                'overflow-hidden',
                                'm-0',
                                'sm:!bg-cover',
                                'bg-gray-15',
                            ])}
                        />
                        <span
                            className={dt([
                                'font-normal',
                                'italic',
                                'text-gray-60',
                                'mx-2',
                                'my-auto',
                            ])}
                        >
                            {ProductConstants.SELECT_A_COLOR}
                        </span>
                    </div>
                )}
            </button>
            <center
                className={`${cx('beautyDDSelect')} ${dt([
                    showItems
                        ? dt([
                              'h-auto',
                              'max-h-64',
                              'overflow-y-auto',
                              'overflow-x-hidden',
                              'absolute',
                              'z-3',
                              'bg-white',
                              '-left-px',
                              'top-full',
                              'rounded-b-lg',
                              'border',
                              'border-solid',
                              'border-gray-60',
                              'border-t-gray-15',
                              'lg:w-[300px]',
                              'smMd:w-[calc(100%+2px)]',
                              'text-left',
                          ])
                        : '',
                ])}`}
            >
                {showItems &&
                    dimensionWithUnavailableFiltersRemoved.options.map((dataItem, index) => (
                        <div
                            key={dataItem.id}
                            className={dt([
                                'flex',
                                'font-normal',
                                'border-gray-15',
                                'border-t',
                                'first:border-t-0',
                                'border-solid',
                                'py-2',
                                'px-4',
                                'lg:w-[300px]',
                                'smMd:w-full',
                            ])}
                            id="dropDownItems"
                        >
                            {props.renderProductOptionsColorItem(
                                props.dimension,
                                dataItem,
                                index,
                                true
                            )}
                        </div>
                    ))}
            </center>
        </div>
    );
};

BeautyDropDown.defaultProps = {
    dimension: {},
    renderProductOptionsColorItem: noop,
    optionsSelected: {},
};

BeautyDropDown.propTypes = {
    dimension: PropTypes.object,
    renderProductOptionsColorItem: PropTypes.func,
    optionsSelected: PropTypes.object,
};

export default BeautyDropDown;
